import _ from "lodash";
import React from "react";
import classes from "./FilterCountBlock.scss";
import classNames from "classnames";
import { Button } from "@toddle-edu/ds-web";
import { onEnterOrSpaceKeyDown } from "Utils";

const FilterCountBlock = props => {
  const {
    filters,
    activeFilter,
    onFilterClick,
    containerStyle = {},
    filterContainerStyle = {},
    filterBoxStyle = {},
    labelStyle = {},
    countStyle = {},
    activeLabelStyle,
    activeCountStyle,
    colorCountText = false,
    isManagePrograms = false,
  } = props;

  const componentTestId = "filterTab";

  return (
    !_.isEmpty(filters) && (
      <div className={classes.container} style={containerStyle}>
        {_.map(
          filters,
          (
            {
              key,
              label,
              value,
              count,
              color,
              isClickable = true,
              isLabelLoading = false,
              isCountLoading = false,
              showButtonWithLabel = false,
              buttonLabel,
              testId,
              onButtonClick,
            },
            index
          ) => {
            const isActiveFilter = activeFilter == value;

            const filterBoxClasses = classNames({
              [classes.filterBox]: true,
              [classes.activeBorder]: isActiveFilter,
              [classes.disableClick]: !isClickable,
            });

            const showEmptyDiv = index < _.size(filters) - 1;

            const filterContainer = classNames({
              [classes.filterContainer]: true,
              [classes.containerBox]: isManagePrograms,
            });

            return (
              <div
                key={key}
                className={filterContainer}
                style={filterContainerStyle}
                {...(isClickable && {
                  onClick: () => onFilterClick(value),
                  onKeyDown: e =>
                    onEnterOrSpaceKeyDown(e, () => onFilterClick(value)),
                  role: "button",
                  tabIndex: 0,
                })}
              >
                <div className={filterBoxClasses} style={filterBoxStyle}>
                  <div
                    className={classes.count}
                    style={{
                      ...countStyle,
                      ...(isActiveFilter ? activeCountStyle : {}),
                      ...(colorCountText && { color }),
                    }}
                  >
                    {isCountLoading ? (
                      <div className={classes.loader} />
                    ) : (
                      count
                    )}
                  </div>
                  <div className={classes.labelContainer}>
                    <div
                      className={classes.label}
                      style={{
                        ...labelStyle,
                        ...(isActiveFilter ? activeLabelStyle : {}),
                        color,
                      }}
                    >
                      {isLabelLoading ? (
                        <div className={classes.loader} />
                      ) : (
                        label
                      )}
                    </div>
                    {showButtonWithLabel && !isLabelLoading ? (
                      <Button
                        dsVersion="2.0"
                        disabled={!isActiveFilter}
                        testId={`${componentTestId}-${testId}`}
                        onClick={onButtonClick}
                      >
                        {buttonLabel}
                      </Button>
                    ) : null}
                  </div>
                </div>
                {showEmptyDiv && <div className={classes.emptyDiv}></div>}
              </div>
            );
          }
        )}
      </div>
    )
  );
};

FilterCountBlock.defaultProps = {
  activeLabelStyle: {},
  activeCountStyle: {},
};

export default FilterCountBlock;
